export default __webpack_public_path__ + "static/frontpage-a71711aa9f4cd9ee80e526c0cb1fc12c.mp4";